<template>
  <div class="c-light-video">
    <div class="c-light-video__video">
      <light-box-video-spinner v-if="!youtubeEmbed" />
      <div v-if="youtubeEmbed" class="c-light-video__youtube">
        <iframe
          :src="youtubeEmbed"
          title="YouTube"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowfullscreen
          referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
      <vue-vimeo-player v-else-if="videoId" :video-id="videoId"></vue-vimeo-player>
    </div>
    <div v-if="videoDescription.length" class="c-light-video__copy">
      <prismic-rich-text :field="videoDescription" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LightBoxVideoSpinner from "@/templates/components/LightBox/LightBoxVideoSpinner";
import PrismicRichText from "objects/PrismicRichText";
import { vueVimeoPlayer } from "vue-vimeo-player";
export default {
  components: {
    LightBoxVideoSpinner,
    PrismicRichText,
    vueVimeoPlayer
  },
  computed: {
    ...mapState({
      videoId: state => state.lightBox.youtubeId,
      videoDescription: state => state.lightBox.videoDescription
    }),
    youtubeEmbed() {
      const id = String(this.videoId || "").trim();
      // Numeric ids stay on Vimeo. An 11-char id is YouTube, including Shorts.
      return /^[A-Za-z0-9_-]{11}$/.test(id) && !/^\d+$/.test(id)
        ? `https://www.youtube.com/embed/${id}`
        : "";
    }
  }
};
</script>

<style lang="scss">
.c-light-video {
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  &__video {
    width: 100%;
    height: 100%;
    padding-bottom: 56.25%;
    position: relative;
    > div {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    > .c-light-video__youtube {
      width: auto;
      aspect-ratio: 9 / 16;
      left: 50%;
      transform: translateX(-50%);
    }
    iframe {
      width: 100%;
      height: 100%;
      border: 0;
    }
  }
  &__copy {
    text-align: center;
    margin-top: var(--grid-gutter-double);
    h3 {
      @include t3-heavy-bold;
      color: $color-dark;
      margin-top: 0px;
    }
  }
}
</style>
